export enum AuthorityAccountReceivable {
  FINANCIAL_ACCOUNT_RECEIVABLE_GROUPING = '3.7',
  FINANCIAL_ACCOUNT_RECEIVABLE_RENEGOTIATE = '3.4.7',
  FINANCIAL_ACCOUNT_RECEIVABLE_SETTLE_REFUND_WITH_PREVIOUS_DATE = '3.4.8',
  FINANCIAL_ACCOUNT_RECEIVABLE_EDIT_DATE_SETTLE_INSTALLMENT = '3.4.6.1',
  FINANCIAL_ACCOUNT_RECEIVABLE_GROUP = '3.7.1',
  FINANCIAL_ACCOUNT_RECEIVABLE_SETTLE = '3.4.6',
  FINANCIAL_ACCOUNT_RECEIVABLE_REFUND_INSTALLMENT = '3.4.5',
  FINANCIAL_ACCOUNT_RECEIVABLE_EDIT = '3.4.4',
  FINANCIAL_ACCOUNT_RECEIVABLE_DELETE_INSTALLMENTS = '3.4.3',
  FINANCIAL_ACCOUNT_RECEIVABLE_ADD = '3.4.2',
  FINANCIAL_ACCOUNT_RECEIVABLE_VIEW = '3.4.1',
  FINANCIAL_ACCOUNT_RECEIVABLE_LAUCH = '3.4',
  FINANCIAL_ACCOUNT_RECEIVABLE_EDIT_VALUE = '3.4.9',
}
